import {
  Center,
  Image,
  Container,
  Text,
  Heading,
  Stack,
  VStack,
  Flex,
} from "@chakra-ui/react";
import PrimaryContact from "../components/vicforms/registrationForm/primaryContact";
import Organisation from "../components/vicforms/registrationForm/organisation";
import {
  VicFormsRegistrationScreens,
  VicFormsRegistrationWizardData,
} from "../components/vicforms/registrationForm/models";
import Success from "../components/vicforms/registrationForm/success";
import Wizard from "../components/wizard/wizard";

const VicFormsRegistrationLayout: React.FC = () => {
  return (
    <Flex bgColor="gray.100" w={"100%"} minH="100vh">
      <Stack w="100%" direction={{ base: "column", lg: "row" }}>
        <VStack
          overflow={"auto"}
          maxH={{ base: undefined, lg: "100vh" }}
          w="100%"
          maxW={{ base: undefined, lg: "600px" }}
          flexShrink={0}
          p={{ base: 4, md: 16 }}
          align={"flex-start"}
          bgColor="white"
        >
          <Center>
            <Image src={`${process.env.PUBLIC_URL}/reiv-logo.png`} />
          </Center>

          <Wizard<VicFormsRegistrationWizardData, VicFormsRegistrationScreens>
            definition={{
              screens: {
                [VicFormsRegistrationScreens.ORGANISATION]: {
                  component: Organisation,
                },
                [VicFormsRegistrationScreens.PRIMARY_CONTACT]: {
                  component: PrimaryContact,
                },
                [VicFormsRegistrationScreens.SUCCESS]: {
                  component: Success,
                },
              },
            }}
            wizardData={{
              [VicFormsRegistrationScreens.ORGANISATION]: {
                abn: "",
                address: "",
                organisationName: "",
                userName: "",
              },
              [VicFormsRegistrationScreens.PRIMARY_CONTACT]: {
                firstName: "",
                lastName: "",
                mobile: "",
                phone: "",
                fax: "",
              },
              [VicFormsRegistrationScreens.SUCCESS]: {},
            }}
          />
        </VStack>

        <Center flexGrow={1}>
          <Container>
            <VStack
              mt={{ base: 8, lg: undefined }}
              p={{ base: "64px 16px", lg: undefined }}
              maxW="600px"
              align={"stretch"}
            >
              <Heading size={"md"}>
                Digital real estate forms for Victorian agencies
              </Heading>
              <Text>
                VicForms is used by Victoria's best-in-class real estate
                agencies to get compliant commercial and residential real estate
                authorities and contracts executed faster and with less noise.
              </Text>
              <Image src={`${process.env.PUBLIC_URL}/vicforms-promo.png`} />
              <Center>
                <Text fontSize="small">
                  VicForms — An REIV initiative, supported by Hutly
                </Text>
              </Center>
            </VStack>
          </Container>
        </Center>
      </Stack>
    </Flex>
  );
};

export default VicFormsRegistrationLayout;
